import React from 'react'
import { Main } from './pages/Main/Main'

export const App: React.FC = () => {
  //  const token: string = authStore((state: AuthStoreType) => state.token) || ''
  //return token ? <Main /> : <Login />
  return <Main />
}
